import { render, staticRenderFns } from "./CreateReward.vue?vue&type=template&id=656de2ca&scoped=true"
import script from "./CreateReward.vue?vue&type=script&lang=js"
export * from "./CreateReward.vue?vue&type=script&lang=js"
import style0 from "./CreateReward.vue?vue&type=style&index=0&id=656de2ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656de2ca",
  null
  
)

export default component.exports